import pickBy from 'utils/pickBy';

/**
 * Pick only defined values from the spec, so it can merge.
 * @param {object} spec Specification values
 * @returns {object}
 */
const pickDefined = spec => {
  return pickBy(spec, value => value != null);
};

/**
 * Merge the multiple specification sources into one by their priority.
 * @param {object} baseSpec Base specification values as defiend in the template.
 * @param {object} [opts]
 * @param {object} [opts.overrideSpec] The override object with values different from the template.
 * @param {object} [opts.styleSpec] Style specification values as defiend in the template.
 * @returns {object} Merged specification object
 */
const mergeSpec = (baseSpec, { overrideSpec, styleSpec } = {}) => {
  return {
    ...pickDefined(baseSpec),
    ...pickDefined(styleSpec),
    ...pickDefined(overrideSpec),
  };
};

export default mergeSpec;
